(function () {
  var SWIPER_RETRIES = 40;
  var SWIPER_RETRY_MS = 50;

  function scheduleUpdate(swiper) {
    requestAnimationFrame(function () {
      swiper.update();
      requestAnimationFrame(function () {
        swiper.update();
      });
    });
    window.setTimeout(function () {
      swiper.update();
    }, 150);
  }

  function getSlidesPerView(swiper) {
    var spv = swiper.params.slidesPerView;
    if (typeof spv === 'string') return parseFloat(spv) || 1;
    return spv;
  }

  function updateNavVisibility(root, swiper, slideCount) {
    var nav = root.querySelector('.related-products-mf__nav');
    if (!nav) return;

    var cols = getSlidesPerView(swiper);
    var shouldHide = slideCount <= cols;
    nav.classList.toggle('related-products-mf__nav--hidden', shouldHide);
    nav.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
  }

  function buildOptionsForRoot(root, prevEl, nextEl, slideCount) {
    var mobile = parseInt(root.dataset.columnsMobile, 10) || 2;
    var tablet = parseInt(root.dataset.columnsTablet, 10) || 3;
    var desktop = parseInt(root.dataset.columnsDesktop, 10) || 4;

    var enableLoop = slideCount > desktop;

    return {
      slidesPerView: mobile,
      spaceBetween: 8,
      slidesPerGroup: 1,
      loop: enableLoop,
      speed: 450,
      watchOverflow: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      on: {
        init: function (swiper) {
          updateNavVisibility(root, swiper, slideCount);
          if (swiper.navigation && typeof swiper.navigation.update === 'function') {
            swiper.navigation.update();
          }
        },
        resize: function (swiper) {
          updateNavVisibility(root, swiper, slideCount);
        },
        breakpoint: function (swiper) {
          updateNavVisibility(root, swiper, slideCount);
        },
        slideChangeTransitionEnd: function (swiper) {
          if (swiper.params.loop && typeof swiper.loopFix === 'function') {
            swiper.loopFix();
          }
        },
      },
      breakpoints: {
        750: {
          slidesPerView: tablet,
          spaceBetween: 12,
        },
        990: {
          slidesPerView: desktop,
          spaceBetween: 16,
        },
      },
    };
  }

  function initSwiper(root) {
    var container = root.querySelector('.js-related-products-swiper');
    if (!container || container.swiper) return;

    var prevEl = root.querySelector('.js-related-products-swiper-prev');
    var nextEl = root.querySelector('.js-related-products-swiper-next');
    if (!prevEl || !nextEl) return;

    var slideCount =
      parseInt(root.dataset.slideCount, 10) ||
      container.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    if (typeof Swiper === 'undefined') return;

    var options = buildOptionsForRoot(root, prevEl, nextEl, slideCount);
    var swiper;

    try {
      swiper = new Swiper(container, options);
    } catch (e) {
      try {
        options.loop = false;
        options.rewind = slideCount > 1;
        swiper = new Swiper(container, options);
      } catch (e2) {
        return;
      }
    }

    scheduleUpdate(swiper);
    window.addEventListener('load', function () {
      scheduleUpdate(swiper);
      updateNavVisibility(root, swiper, slideCount);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-related-products-swiper]').forEach(initSwiper);
  }

  function waitForSwiperAndInit() {
    if (typeof Swiper !== 'undefined') {
      initAll();
      return;
    }
    var left = SWIPER_RETRIES;
    var id = window.setInterval(function () {
      left -= 1;
      if (typeof Swiper !== 'undefined') {
        window.clearInterval(id);
        initAll();
        return;
      }
      if (left <= 0) {
        window.clearInterval(id);
      }
    }, SWIPER_RETRY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiperAndInit);
  } else {
    waitForSwiperAndInit();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var roots = event.target.querySelectorAll('[data-related-products-swiper]');
    if (!roots.length) return;

    function runSectionInits() {
      if (typeof Swiper === 'undefined') return false;
      roots.forEach(initSwiper);
      return true;
    }

    if (runSectionInits()) return;

    var left = SWIPER_RETRIES;
    var id = window.setInterval(function () {
      if (runSectionInits() || left-- <= 0) window.clearInterval(id);
    }, SWIPER_RETRY_MS);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.querySelectorAll('[data-related-products-swiper]');
    roots.forEach(function (root) {
      var el = root.querySelector('.js-related-products-swiper');
      if (el && el.swiper) el.swiper.destroy(true, true);
    });
  });
})();
